export default "__VITE_ASSET__b5979c8d__"